import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { bannerData } from "./../../Datas/PersonalData/bannerData";
import { notify } from "../../Datas/Functions/toast";

const BannerListSection = ({setSelectedBanner}) => {
  const [bannerList, setBannerList] = useState([]);
  useEffect(() => {
    setBannerList(bannerData);
  }, []);
  const deleteBanner = (id) => {
    notify("Successfully Deleted", "Banner has been deleted", "success");
  };
  return (
    <div className="col-span-12 md:col-span-7 ">
      <div className="box max-h-screen overflow-scroll dark:dark-bg-front bg-front">
        <h1 className="text-center text-2xl font-bold mb-5 py-5">
          Banner List
        </h1>
        <table className=" w-full overflow-x-scroll table">
          <thead>
            <tr>
              <th className="p-3 font-bold uppercase bg-back dark:dark-bg-back   dark:dark-text border border-gray-300 ">
                Title
              </th>
              <th className="p-3 font-bold uppercase  bg-back dark:dark-bg-back  dark:dark-text border border-gray-300 ">
                Image Source
              </th>
              <th className="p-3 font-bold uppercase  bg-back dark:dark-bg-back    dark:dark-text border border-gray-300 ">
                Link
              </th>
              <th className="p-3 font-bold uppercase  bg-back dark:dark-bg-back    dark:dark-text border border-gray-300 ">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {bannerList.length > 0 ? (
              bannerList.map((item, i) => (
                <tr
                  key={i}
                  className="cursor-pointer text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800  duration-200"
                >
                  <td className="w-auto p-3   border border-b   ">
                    {item.title}
                  </td>
                  <td className="w-auto p-3   border border-b text-center    ">
                    <a
                      className="text-blue-600 underline"
                      href={item.src}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {" "}
                      View Image
                    </a>
                  </td>
                  <td className="w-auto p-3   border border-b text-center   ">
                    {item.link ? (
                      <a
                        className="text-blue-600 underline"
                        href={item.link}
                        rel="noreferrer noopener"
                      >
                        View Link
                      </a>
                    ) : (
                      "Not Available"
                    )}
                  </td>
                  <td className="w-auto p-3   border border-b text-center    ">
                    <button
                      className="pr-3"
                      onClick={() => setSelectedBanner(item)}
                    >
                      <i className="fas fa-edit    "></i>
                    </button>
                    <button
                      className="pl-3"
                      onClick={() => deleteBanner(i)}
                    >
                      <i
                        className="fa fa-trash text-red-600"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={"100%"}>
                  <h1 className="text-3xl text-center">
                    No Banner Data Available
                  </h1>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BannerListSection;
